/* A later service of a visit going up before an earlier one, on the same
 * technician.
 *
 * Edna, 2026-10-19: a Hard Gel Manicure at 1:30 and a Classic Pedicure at
 * 2:35, both with Helen. The pedicure's square went up first and the manicure
 * sat in Due now. One technician does a visit's services in the book's order,
 * so a square for the second while the first has none is more likely a slip
 * than a plan — but not certainly (the client may have asked to swap them), so
 * the board asks rather than decides (Kevin, 2026-10-19: warn, let the desk
 * choose).
 *
 * Pure. `lines` are the visit's booked services as
 * { id, startsAt, mine, seated, over }:
 *   mine     the book has them with the technician the square is going on
 *   seated   already on the board (a square of its own, or part of one)
 *   over     nothing to do — the visit has checked out, or it is an add-on
 *            already covered by a square
 * Returns the id of the earliest such line still waiting to go up, booked
 * before `targetId`, or null.
 */
export function earlierFirst(targetId, lines) {
  var list = lines || [];
  var target = list.find(function (l) { return l.id === targetId; });
  if (!target) return null;
  var waiting = list.filter(function (l) {
    return l.id !== targetId && l.mine && !l.seated && !l.over && l.startsAt < target.startsAt;
  }).sort(function (a, b) { return a.startsAt - b.startsAt; });
  return waiting.length ? waiting[0].id : null;
}
